import styled from 'styled-components'
import Link from './link'

const DiscreetLink = styled(Link)`
  color: #212529;
`

export default DiscreetLink